//mui
import {Theme} from '@mui/material';

export const MuiCircularProgress = {
	styleOverrides: {
		root: ({theme}: {theme: Theme}) => ({
			'&.MuiCircularProgress-root': {
				color: theme.palette.neutral900,
			},
		}),
	},
};
